module.exports = __webpack_public_path__ + "static/img/pic.1f1563c7.jpg";